import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { FuseConfirmationConfig } from '@fuse/services/confirmation';
import { FuseConfirmationConfigCustom } from 'app/models/fuseConfirmationConfigCustom';
import { Modal } from 'app/models/modal';
import { CompaniesModule } from '../../modules/companies/companies.module';
import { AddCompanyPositionComponent } from '../../modules/companies/components/add-company-position/add-company-position.component';
import { OrganizationChartsPosition } from '../../models/companies';
import { environment } from '../../../environments/environment';
import { User } from 'app/models/user';
import { companyDepartmentOptions } from 'app/models/company-departments';


@Component({
    selector: 'app-organization-chart-position-add-quick',
    templateUrl: './organization-chart-position-add-quick.component.html',
    styleUrls: ['./organization-chart-position-add-quick.component.scss'],
    styles: [
        `
      .fuse-confirmation-dialog-panel {

          @screen md {
              @apply w-128;
          }

          .mat-mdc-dialog-container {

              .mat-mdc-dialog-surface {
                  padding: 0 !important;
              }
          }
      }
  `
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrganizationChartPositionAddQuickComponent implements OnInit{


    inputValue: string = '';
    parentPosition: number = -1;
    department: string = '';
    departmentOptions: string[] = [];
    data: FuseConfirmationConfigCustom;

    inputForm: UntypedFormGroup;
    currentPosition?: OrganizationChartsPosition;
    currentUser?: number;
    initCurrentUser?: number;

    showChangeParent: boolean = true;
    showRootOption: boolean = true;

    positions: OrganizationChartsPosition[];
    users?: User[];
    btn_text?: string;

    constructor(
        private dialogRef: MatDialogRef<OrganizationChartPositionAddQuickComponent>,
        @Inject(MAT_DIALOG_DATA) public dataInput: FuseConfirmationConfigCustom,
        private _formBuilder: UntypedFormBuilder,
    ) {
        console.log(this.dataInput);

        if (dataInput) {
            this.data = dataInput;

            if(this.data.other && this.data.other.btn_text){
                this.btn_text = this.data.other.btn_text;
            }

            if(this.data.other && this.data.other.department){
                this.department = this.data.other.department;
            }

            if(this.data.other && this.data.other.id){

                if(this.data.other.positions){
                    console.log(this.data.other.id);
                    // Filtrar posiciones para evitar referencias circulares y excluir la posición por defecto
                    this.positions = this.data.other.positions.filter( (x:OrganizationChartsPosition)=> { 
                        return x.name != environment.nameDefaultPosition && x.id != this.data.other.id;
                    });

                    this.currentPosition = this.data.other.positions.find( (x:OrganizationChartsPosition)=> { return x.id == this.data.other.id});
                    console.log(this.currentPosition);
                    this.inputValue = this.currentPosition.name
                    this.parentPosition = (this.currentPosition.parent != null )?this.currentPosition.parent.id:-1;
                    // Siempre permitir cambiar el cargo padre
                    this.showChangeParent = true;

                    if(this.currentPosition.department){
                        this.department = this.currentPosition.department.name;
                    }

                    // Verificar si hay un cargo raíz actual diferente a esta posición
                    const existingRootPosition = this.data.other.positions.find(
                        (x: OrganizationChartsPosition) => x.id_parent_position === null && x.id !== this.data.other.id
                    );
                    
                    // Permitir cambiar a raíz si:
                    // 1. No hay otro cargo raíz, O
                    // 2. Esta posición actualmente ES el cargo raíz
                    this.showRootOption = !existingRootPosition || this.currentPosition.id_parent_position === null;


                }else if(this.data.other.position && this.data.other.users){
                    this.users = [ ...this.data.other.users ];
                    this.positions = [ this.data.other.position ];
                    this.currentPosition = this.data.other.position.id;
                    this.inputValue = this.data.other.position.name
                    this.parentPosition = (this.currentPosition.parent != null )?this.currentPosition.parent.id:-1;
                    // Permitir cambiar el cargo padre incluso para cargos raíz
                    this.showChangeParent = true;

                    this.currentUser = -1;
                    if(this.data.other.id_user){
                        this.currentUser = this.data.other.id_user
                    }
                    this.initCurrentUser = this.currentUser;
                }
            }else{
                this.positions = this.data.other.filter( (x:OrganizationChartsPosition)=> { return x.name != environment.nameDefaultPosition});
                this.parentPosition = this.positions.length > 0?this.positions[this.positions.length - 1].id:-1;
                
                // Para crear nueva posición, verificar si ya existe un cargo raíz
                const existingRootPosition = this.data.other.find(
                    (x: OrganizationChartsPosition) => x.id_parent_position === null
                );
                
                // Si ya existe un cargo raíz, no permitir crear otro
                this.showRootOption = !existingRootPosition;
            }
        }


        const allPositions: OrganizationChartsPosition[] = Array.isArray(this.data?.other)
            ? this.data.other : (this.data?.other?.positions ?? this.positions ?? []);
        this.departmentOptions = companyDepartmentOptions([
            this.department, ...allPositions.map(position => position.department?.name)
        ]);

        this.inputForm = this._formBuilder.group({
            name: [this.inputValue, Validators.required],
            position: [this.parentPosition], // Remover validación requerida para permitir cargo raíz
            department: [this.department, Validators.required],
            user: [this.currentUser, (this.currentUser)?Validators.required:Validators.nullValidator]
        });

        console.log(this.inputForm.get('position').value);
        console.log(this.inputForm.get('user').value);
    }

    ngOnInit(): void {
        // Recalcular showRootOption siempre que se abra el modal
        if (this.positions) {
            const existingRootPosition = this.positions.find(
                (x: OrganizationChartsPosition) => x.id_parent_position === null
            );
            // Si no hay raíz, permitir la opción
            this.showRootOption = !existingRootPosition;
        }
        // Si es edición, permitir raíz si es el propio cargo
        if (this.currentPosition && this.currentPosition.id_parent_position === null) {
            this.showRootOption = true;
        }
    }

    onParentChange(event: MatSelectChange): void {
        console.log('Parent changed to:', event.value);
        console.log('Will send as parent:', event.value === -1 ? null : event.value);
        
        // Si se intenta seleccionar cargo raíz pero no está permitido, revertir la selección
        if (event.value === -1 && !this.showRootOption) {
            // Seleccionar la primera opción disponible en su lugar
            if (this.positions && this.positions.length > 0) {
                this.parentPosition = this.positions[0].id;
                this.inputForm.get('position')?.setValue(this.positions[0].id);
            }
            return;
        }
        
        this.parentPosition = event.value;
    }

    get validate(): boolean {

        if (this.inputValue == "" || this.inputForm.invalid) {
            return false;
        }

        // Validación adicional: si se seleccionó cargo raíz pero no está permitido
        if (this.parentPosition === -1 && !this.showRootOption) {
            return false;
        }

        return true;
    }



}
